'use strict';

function UploaderRoutes ($stateProvider) {
  $stateProvider
  .state('uploader', {
    url: '/uploader',
    controller: 'UploaderPageController',
    controllerAs: 'vm',
    templateUrl: 'uploader/index.tpl.html',
    resolve: {

      authenticate: [
        '$location', '$state', '$q', '$timeout', 'AuthService',
        ($location, $state, $q, $timeout, AuthService, PlanStore, OrganizationStore) => {

          const deferred = $q.defer();
          const authenticated = AuthService.isAuthenticated();
          const params = {
            location: $location.path() === '/' ? '' : $location.path()
          };

          $timeout(() => {

            if (authenticated) {
              deferred.resolve();
            }
            else {
              $state.go('login', params);
              deferred.reject();
            }
          });

          return deferred.promise;
        }
      ],

      organization: [
        '$state', 'sbFlux', 'authenticate', 'IngestorService',
        ($state, Flux, authenticate, IngestorService) => {

          var OrganizationStore = Flux.Store.get('OrganizationStore');
          var PlanStore = Flux.Store.get('PlanStore');
          return OrganizationStore.loadOrganization()
          .then((organization) => {

            return PlanStore.preloadOrgPlanData()
          })
          .then(() => {
            const isEnabledPlan = PlanStore.get('orgPlan').isEnabled;
            if (!isEnabledPlan) {
              $state.go('dash.map');
            }
            IngestorService.attachIngestor()
          })

        }
      ]
    }
  })
}

UploaderRoutes.$inject = ['$stateProvider'];
module.exports = UploaderRoutes;



// WEBPACK FOOTER //
// ./src/app/uploader/UploaderRoutes.js